<template>
  <form-element class="checkboxGroup" v-bind="$props">
    <label v-if="isMultiMode && titleLabel" class="checkboxGroup-title">{{
      titleLabel
    }}</label>
    <checkbox
      v-for="(item, i) in localItems"
      :key="i"
      v-model="item.checked"
      class="checkboxGroup-item"
      :class="{
        'checkboxGroup-item--error': !isEmpty(errors) && !item.checked,
      }"
      :name="item.name"
      :text="item.name"
    ></checkbox>
  </form-element>
</template>

<script>
import { isEmpty } from 'lodash'

import FormElement from '../../../components/FormElement'

export default {
  name: 'CheckboxGroup',

  components: {
    FormElement,
    Checkbox: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/Checkbox'
      )
    },
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    titleLabel: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'multi',
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    tooltipContent: {
      type: String,
      default: '',
    },
    tooltipLabel: {
      type: String,
      default: '',
    },
    required: Boolean,
  },

  data() {
    return {
      inputValue: [],
      localItems: [],
    }
  },

  computed: {
    isMultiMode() {
      return this.mode !== 'single'
    },
  },

  watch: {
    localItems: {
      handler(value) {
        this.inputValue = value.filter(el => el.checked).map(el => el.value)
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.localItems = this.items.map(el => {
      return {
        ...el,
        checked: el.checked || false,
      }
    })
  },

  methods: {
    isEmpty,
  },
}
</script>

<style lang="postcss">
.checkboxGroup {
  margin: var(--spacing-4) 0 var(--spacing-2);
  display: inline-block;
}

.checkboxGroup-title {
  font-weight: 700;
  font-style: normal;
  font-size: 15px;
  line-height: 1.35;
  color: var(--c-primary-neutral-1);
  display: block;
  margin-bottom: 20px;
}

.checkboxGroup-item {
  margin-bottom: 12px;
}

/* Needs to be specific enough to override the default */
.checkboxGroup-item--error svg.dotcom-icon {
  color: var(--c-secondary-color-1);
}
</style>
